<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="error d-flex flex-row-fluid bgi-size-cover bgi-position-center"
      style="background-image: url(/media/error/404.jpg)"
    >
      <div
        class="px-10 px-md-30 py-10 py-md-0 d-flex flex-column justify-content-md-center"
      >
        <h1 class="error-title text-stroke text-transparent">404</h1>

        <p class="display-4 font-weight-boldest text-white mb-5">
          How did you get here?
        </p>
        <p class="font-size-h4 font-weight-bolder text-dark-75">
          Sorry we can't find the page you're looking for.
        </p>
        <router-link to="/">
          <p class="font-size-h4 font-weight-bolder text-dark-75">
            Go back to home
          </p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "404-NotFound",
};
</script>

<style lang="scss">
@import "~@/assets/sass/pages/error.scss";
</style>
